import { useQuery } from '@apollo/react-hooks';

import { ADMIN_USER_CHANNEL_SUBSCRIPTIONS } from '../../../../../gql/users';
import {
    UserChannelSubscriptionsData,
    UserChannelSubscriptionsProps,
    UserChannelSubscriptionsVariables,
} from '../types';

const useUserChannelSubscriptions = ({
    isAdmin,
    userId,
}: UserChannelSubscriptionsProps) =>
    useQuery<UserChannelSubscriptionsData, UserChannelSubscriptionsVariables>(
        ADMIN_USER_CHANNEL_SUBSCRIPTIONS,
        {
            skip: !isAdmin || !userId,
            fetchPolicy: 'network-only',
            variables: userId ? { userId } : undefined,
        }
    );

export default useUserChannelSubscriptions;
